let busylightSharedWorker: SharedWorker | null = null;

export const getBusylightSharedWorkerConnection = (): SharedWorker => {
  if (!busylightSharedWorker) {
    busylightSharedWorker = new SharedWorker(
      new URL('./busylight.sharedWorker.ts', import.meta.url),
      {
        name: 'dixa-busylight-shared-worker',
        type: 'module',
      },
    );
  }
  return busylightSharedWorker;
};
